import { render, staticRenderFns } from "./forgot-password-box.vue?vue&type=template&id=6fecdd20"
import script from "./forgot-password-box.vue?vue&type=script&lang=js"
export * from "./forgot-password-box.vue?vue&type=script&lang=js"
import style0 from "./forgot-password-box.vue?vue&type=style&index=0&id=6fecdd20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports